import { useRef, useState, useLayoutEffect } from 'react';
import Toolbar from './components/Toolbar';
import Table from './components/Table';
import List from './hooks/List';

const ActivitiesList = (props) => {
  const vm = List(props);

  const stickyHeaderRef = useRef(null);
  const [stickyOffset, setStickyOffset] = useState(0);

  useLayoutEffect(() => {
    const el = stickyHeaderRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => setStickyOffset(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white shadow-md rounded-lg" style={{ overflow: 'clip' }}>
      {/* Scroll de página: este bloque (título + filtro) queda fijo con un pequeño espacio
          arriba (sticky top-3, bajo la capa de fondo) mientras el body de la tabla se desplaza. */}
      <div ref={stickyHeaderRef} className="md:sticky md:top-3 md:z-20 md:bg-white">
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Actividades</h2>
        </div>
        <Toolbar
          query={vm.query}
          setQuery={vm.setQuery}
        />
      </div>
      <Table
        loading={vm.loading}
        filteredActivities={vm.filteredActivities}
        query={vm.query}
        sortConfig={vm.sortConfig}
        handleSort={vm.handleSort}
        stickyOffset={stickyOffset}
      />
    </div>
  );
};

export default ActivitiesList;
